





























































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  AppUserFilter,
  CustomerFilter,
  ProjectFilter,
  ProjectTaskFilter,
  StSelectListItemGroup,
  TimeEntryExtraFieldDataTypeEnum,
  TimeEntryExtraFieldMetadataViewModel,
  TimeEntryFilter,
  TimeEntryFilterExtraField,
  TimeEntryFilterTimeFrame
} from "@/services/api/nswag/stapiclient_generated";
import { DateTime } from "luxon";
import TimeFrame from "@/components/timeentry-filter/timeframe";
import {
  stAppUserApi,
  stCustomerApi,
  stProjectApi,
  stProjectTaskApi,
  stTagApi,
  timeEntryExtraFieldMetadataClient
} from "@/services/st-api";
import StInput2 from "@/components/basic/StInput2.vue";

import { UserStore } from "@/store/user-module";
import { FilterControl } from "@/components/timeentry-filter/filterControl";

@Component({
  computed: {
    TimeEntryExtraFieldDataTypeEnum() {
      return TimeEntryExtraFieldDataTypeEnum
    }
  },
  components: { StInput2 }
})
export default class TimeEntryFilterComponent extends Vue {
  @Prop() value!: TimeEntryFilter;
  @Prop() singleCustomer!: boolean;
  @Prop() filterControl?: FilterControl;
  timeFrameSelectDummyValue = "dummy";
  budgetUnit: string = "Hours";
  tags: StSelectListItemGroup[] = [];
  customers: StSelectListItemGroup[] = [];
  projects: StSelectListItemGroup[] = [];
  appUser: StSelectListItemGroup[] = [];
  projectTasks: StSelectListItemGroup[] = [];
  internalDateFrom: string = "";
  internalDateTo: string = "";
  selectsLoaded = false;
  projectFilter = ProjectFilter.fromJS({ includeViewOnlyProjects: true });
  customerFilter = CustomerFilter.fromJS({ includeViewOnlyCustomer: true });
  projectTaskFilter = ProjectTaskFilter.fromJS({});
  appUserFilter = AppUserFilter.fromJS({});
  tagFilter = AppUserFilter.fromJS({});
  internalDescriptionFilter = "";
  descriptionTimeout: any;
  timeFrames: TimeFrame[] = [];
  extraFields: TimeEntryExtraFieldMetadataViewModel[] = [];
  displayProps: string[] = [];

  get internalFilter() {
    return this.value;
  }

  @Watch("value.customerIds")
  async internalCustomerIdsChanged() {
    if (this.singleCustomer) {
      await this.loadProjectSelect();
    }
  }

  @Watch("value.timeframe")
  timeFrameChanged() {
    if (this.value.timeframe == TimeEntryFilterTimeFrame.Custom) {
      return;
    }
    const timeframe = this.timeFrames.find((_) => _.Name == this.internalFilter.timeframe);

    if (timeframe) {
      this.selectTimeFrame(timeframe);
    }
  }

  @Watch("internalFilter.extraFields")
  internalFilterExtraFieldsChanged() {
    this.internalExtraFields = JSON.parse(JSON.stringify(this.internalFilter?.extraFields ?? []));
  }

  @Watch("internalFilter.description")
  internalFilterDescriptionChanged() {
    this.internalDescriptionFilter = this.internalFilter.description ?? "";
  }

  created() {
    //Settings.now = () => new Date(2018, 4, 25).valueOf();
    this.createTimeFrames();
  }

  async mounted() {
    this.$emit("startLoading");

    if (this.singleCustomer) {
      this.projectFilter.customerId = this.value!.customerIds![0];
    }

    await Promise.all([this.loadTagSelect(), this.loadCustomerSelect(), this.loadProjectSelect(),
      this.loadAppUserSelect(), this.loadProjecTaskSelect(), this.loadExtraFields()]);

    await this.$nextTick();
    this.timeFrameChanged();
    this.$emit("endLoading");

    this.selectsLoaded = true;
  }

  get showOnlyDate(){
    if(!this.filterControl){
      return false;
    }

    return this.filterControl.showOnlyDate;
  }

  elementIsVisible(elem: string){
    if(!this.filterControl){
      return true;
    }

    if(this.filterControl?.showOnlyDate){
      return elem == 'date';
    }
    //Zeitraum == 'date'
    return (this.filterControl?.hiddenElements ?? []).indexOf(elem) == -1;
  }

  get useProjectTimeTracking() {
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
  }

  get internalFilterExtraFieldsLength() {
    return this.internalFilter.extraFields?.length ?? 0;
  }

  getExtraFieldFilterText(id: number) {
    return this.internalExtraFields.find(x => x.timeEntryExtraFieldMetadataId == id)?.searchText;
  }

  extraFieldTimeout: any;
  internalExtraFields: TimeEntryFilterExtraField[] = [];

  setExtraFieldFilterText(id: number, text: string) {

    this.internalExtraFields = JSON.parse(JSON.stringify(this.internalFilter?.extraFields ?? []));

    if (!this.getExtraFieldFilterText(id) && text) {
      this.internalExtraFields.push({
        timeEntryExtraFieldMetadataId: id,
        searchText: text
      } as TimeEntryFilterExtraField);
    }

    if (this.getExtraFieldFilterText(id) && !text) {
      this.internalExtraFields.splice(this.internalExtraFields.findIndex(x => x.timeEntryExtraFieldMetadataId == id), 1);
    }

    if (this.getExtraFieldFilterText(id) && text) {
      this.internalExtraFields.find(x => x.timeEntryExtraFieldMetadataId == id)!.searchText = text;
    }

    if (this.extraFieldTimeout) {
      clearTimeout(this.extraFieldTimeout);
    }

    this.extraFieldTimeout = setTimeout(() => this.internalFilterUpdated("extraFields", this.internalExtraFields), 1000);
  }

  get hasOutgoingInvoices() {
    return UserStore.userSettings.hasOutgoingInvoices;
  }

  get hasTags() {
    return this.tags.length;
  }

  get hasProjectTasks() {
    return (this.projectTasks?.flatMap(x => x.items)?.length ?? 0);
  }

  get hasMultipleUsers() {
    return (this.appUser?.flatMap(x => x.items)?.length ?? 0) > 1;
  }

  get descriptionFilter() {
    return this.internalDescriptionFilter;
  }

  set descriptionFilter(val: string) {
    this.internalDescriptionFilter = val;

    if (this.descriptionTimeout) {
      clearTimeout(this.descriptionTimeout);
    }

    this.descriptionTimeout = setTimeout(() => this.internalFilterUpdated("description", val), 1000);
  }

  get userNowDateTime() {
    return DateTime.fromISO(UserStore.userSettings.userNowDateTime);
  }

  get firstSelectedCustomer() {
    if (this.internalFilter?.customerIds?.length) {
      return this.customers?.flatMap((x) => x.items)?.find((x) => x!.id == this.internalFilter!.customerIds![0]!)?.description ?? "";
    }
    return "";
  }

  get datePattern() {
    return UserStore.userSettings.datePattern ?? "dd.MM.yyyy";
  }

  get timeFrameLabel() {
    if (!this.internalFilter) {
      return "";
    }

    const namedTimeFrame = this.timeFrames.find((_) => _.Name == this.internalFilter.timeframe);

    if (namedTimeFrame) {
      return namedTimeFrame.Label;
    } else {
      return (
        DateTime.fromISO(this.internalFilter.entryDateFrom!).toFormat(this.datePattern) + " - " + DateTime.fromISO(this.internalFilter.entryDateTo!).toFormat(this.datePattern)
      );
    }
  }

  get invoicedOptions(): any[] {
    return [
      { id: null, description: this.$t("Alle") },
      { id: true, description: this.$t("Abgerechnet") },
      { id: false, description: this.$t("Nicht abgerechnet") }
    ];
  }

  get billableOptions(): any[] {
    return [
      { id: null, description: this.$t("Alle") },
      { id: true, description: this.$t("Verrechenbar") },
      { id: false, description: this.$t("Nicht verrechenbar") }
    ];
  }

  get clearedOptions(): any[] {
    return [
      { id: null, description: this.$t("Alle") },
      { id: true, description: this.$t("Abgeschlossen") },
      { id: false, description: this.$t("Nicht abgeschlossen") }
    ];
  }

  get yesNoOptions(): any[]{
    return [
      { id: null, description: this.$t("Alle") },
      { id: 'true', description: this.$t("Ja") },
      { id: 'false', description: this.$t("Nein") }
    ];
  }

  get budgetUnitOptions() {
    return [
      { id: "Currency", description: UserStore.userSettings.currency },
      { id: "Hours", description: "Stunden" }
    ];
  }

  async loadExtraFields() {
    this.extraFields = (await timeEntryExtraFieldMetadataClient.getList()).filter(x => x.dataType != TimeEntryExtraFieldDataTypeEnum.Rating);
  }

  async loadCustomerSelect() {
    this.customers = await stCustomerApi.getSelectListForFilter(this.customerFilter);
  }

  async loadProjectSelect() {
    if (this.singleCustomer) {
      this.projectFilter.customerId = this.value!.customerIds![0];
    }
    this.projects = await stProjectApi.getSelectListForFilter(this.projectFilter);
  }

  async loadProjecTaskSelect() {
    this.projectTasks = await stProjectTaskApi.getSelectListForFilter(this.projectTaskFilter);
  }

  async loadAppUserSelect() {
    this.appUser = await stAppUserApi.getSelectListForFilter(this.appUserFilter);
  }

  async loadTagSelect() {
    this.tags = await stTagApi.getSelectListForFilter(this.tagFilter);
  }

  triggerTimeFrameSelectValueChange() {
    this.timeFrameSelectDummyValue = "";
    setTimeout(() => {
      this.timeFrameSelectDummyValue = "dummy";
    }, 100);
  }

  async internalFilterUpdated(prop: string, val: any, noApply: boolean = false) {
    let clone: any = { ...this.value, [prop]: val };
    this.$emit("input", clone);
    if (!noApply) {
      await this.$nextTick();
      this.$emit("applyFilter");
    }

    await this.$nextTick();
    if (!val || Array.isArray(val) && !val.length) {
      this.removeDisplayProp(prop);
    }
  }

  // START - TimeFrame handling
  createTimeFrames() {
    //TODO: $t
    this.timeFrames.push(new TimeFrame(this.userNowDateTime, this.userNowDateTime, TimeEntryFilterTimeFrame.Today, this.$t("Heute").toString()));
    this.timeFrames.push(
      new TimeFrame(this.userNowDateTime.minus({ days: 1 }), this.userNowDateTime.minus({ days: 1 }), TimeEntryFilterTimeFrame.Yesterday, this.$t("Gestern").toString())
    );

    this.timeFrames.push(
      new TimeFrame(this.userNowDateTime.startOf("week"), this.userNowDateTime.endOf("week"), TimeEntryFilterTimeFrame.ThisWeek, this.$t("Diese Woche").toString())
    );

    this.timeFrames.push(
      new TimeFrame(
        this.userNowDateTime.startOf("week").minus({ days: 7 }),
        this.userNowDateTime.endOf("week").minus({ days: 7 }),
        TimeEntryFilterTimeFrame.LastWeek,
        this.$t("Letzte Woche").toString()
      )
    );
    this.timeFrames.push(
      new TimeFrame(this.userNowDateTime.minus({ days: 6 }), this.userNowDateTime.minus({ days: 0 }), TimeEntryFilterTimeFrame.Last7, this.$t("Letzte 7 Tage").toString())
    );

    this.timeFrames.push(
      new TimeFrame(this.userNowDateTime.minus({ days: 29 }), this.userNowDateTime.minus({ days: 0 }), TimeEntryFilterTimeFrame.Last30, this.$t("Letzte 30 Tage").toString())
    );
    this.timeFrames.push(
      new TimeFrame(this.userNowDateTime.startOf("month"), this.userNowDateTime.minus({ days: 0 }), TimeEntryFilterTimeFrame.Mtd, this.$t("Dieser Monat bis heute").toString())
    );
    this.timeFrames.push(
      new TimeFrame(this.userNowDateTime.startOf("month"), this.userNowDateTime.endOf("month"), TimeEntryFilterTimeFrame.ThisMonth, this.$t("Dieser Monat (gesamt)").toString())
    );

    this.timeFrames.push(
      new TimeFrame(
        this.userNowDateTime.minus({ months: 1 }).startOf("month"),
        this.userNowDateTime.minus({ months: 1 }).endOf("month"),
        TimeEntryFilterTimeFrame.LastMonth,
        this.$t("Letzter Monat").toString()
      )
    );

    this.timeFrames.push(
      new TimeFrame(
        this.userNowDateTime.startOf("quarter"),
        this.userNowDateTime.endOf("quarter"),
        TimeEntryFilterTimeFrame.ThisQuarter,
        this.$t("Dieses Quartal").toString()
      )
    );

    this.timeFrames.push(
      new TimeFrame(
        this.userNowDateTime.startOf("quarter").minus({ days: 1 }).startOf("quarter"),
        this.userNowDateTime.startOf("quarter").minus({ days: 1 }).endOf("quarter"),
        TimeEntryFilterTimeFrame.LastQuarter,
        this.$t("Letztes Quartal").toString()
      )
    );


    this.timeFrames.push(new TimeFrame(this.userNowDateTime.startOf("year"), this.userNowDateTime, TimeEntryFilterTimeFrame.Ytd, this.$t("Dieses Jahr bis heute").toString()));
    this.timeFrames.push(
      new TimeFrame(this.userNowDateTime.startOf("year"), this.userNowDateTime.endOf("year"), TimeEntryFilterTimeFrame.ThisYear, this.$t("Dieses Jahr (gesamt)").toString())
    );
    this.timeFrames.push(
      new TimeFrame(
        this.userNowDateTime.minus({ years: 1 }).startOf("year"),
        this.userNowDateTime.minus({ years: 1 }).endOf("year"),
        TimeEntryFilterTimeFrame.LastYear,
        this.$t("Letztes Jahr").toString()
      )
    );
    this.timeFrames.push(new TimeFrame(DateTime.fromISO("2010-01-01"), DateTime.fromISO("2030-01-01"), TimeEntryFilterTimeFrame.All, this.$t("Alles").toString()));
  }

  reset() {
    this.displayProps = [];
  }

  isTimeFrameActive(timeFrame: TimeFrame) {
    return this.internalFilter.timeframe == timeFrame.Name;
  }

  async selectCustomTimeFrame() {
    let clone: any = {
      ...this.value,
      timeframe: TimeEntryFilterTimeFrame.Custom
    };
    this.$emit("input", clone);
    await this.$nextTick();
    this.$emit("applyFilter");
    this.triggerTimeFrameSelectValueChange();
  }

  async selectTimeFrame(timeFrame: TimeFrame) {
    let clone: any = {
      ...this.value,
      entryDateFrom: timeFrame.IsoFrom,
      entryDateTo: timeFrame.IsoTo,
      timeframe: timeFrame.Name
    };
    this.$emit("input", clone);
    await this.$nextTick();
    this.$emit("applyFilter");
    this.triggerTimeFrameSelectValueChange();
  }

  async addFilter(name: string) {
    switch (name) {
      case "customerIds":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.customerSelect as any).open();
        break;
      case "projectIds":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.projectSelect as any).open();
        break;
      case "appUserIds":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.appUserSelect as any).open();
        break;
      case "tagIds":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.tagSelect as any).open();
        break;
      case "projectTaskIds":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.projectTaskSelect as any).open();
        break;
      case "description":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.description as any).click();
        break;
      case "isBillable":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.billableSelect as any).open();
        break;
      case "hasOutgoingInvoice":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.invoicedSelect as any).open();
        break;
      case "isCleared":
        this.displayProps.push(name);
        await this.$nextTick();
        (this.$refs.clearedSelect as any).open();
        break;
      case "extrafields":
        this.displayProps.push(name);
        break;
    }
  }

  hasDisplayProp(name: string) {
    return this.displayProps.indexOf(name) > -1;
  }

  removeDisplayProp(name: string) {
    let i = 0;
    while (i < this.displayProps.length) {
      if (this.displayProps[i] === name) {
        this.displayProps.splice(i, 1);
      } else {
        i++;
      }
    }
  }

  async removeFilter(name: string) {
    switch (name) {
      case "description":
        await this.internalFilterUpdated(name, "");
        this.internalDescriptionFilter = "";
        break;
      case "isBillable":
        await this.internalFilterUpdated(name, null);
        break;
      case "hasOutgoingInvoice":
        await this.internalFilterUpdated(name, null);
        break;
      case "isCleared":
        await this.internalFilterUpdated(name, null);
        break;
      default:
        await this.internalFilterUpdated(name, []);
    }
  }

  // END - TimeFrame handling
}
